import NoticeList from 'components/notice/NoticeList.vue'
import NoticeEdit from 'components/notice/NoticeEdit.vue'
import NoticeDetail from 'components/notice/NoticeDetail.vue'

// 通知
export let admin_notice_list = {
  path: 'notice/list',
  component: NoticeList,
}
export let admin_notice_edit = {
  path: 'notice/edit',
  component: NoticeEdit,
}
export let admin_notice_detail = {
  path: 'notice/detail',
  component: NoticeDetail,
}

export let admin_notice_routes = [
  admin_notice_list,
  admin_notice_edit,
  admin_notice_detail,
]

export let admin_notice_map = {
  admin_notice_list,
  admin_notice_edit,
  admin_notice_detail,
}



// WEBPACK FOOTER //
// ./src/router/routes/admin/notice.js